import React from "react";

const Packs = () => {
  return <div>Packs</div>;
};

export default Packs;
